






















import Vue from 'vue';
import massVuex from '../vuex/common';
import NotifySet from '../components/broadcast/NotifySet.vue';
import TimeSet from '../components/broadcast/TimeSet.vue';
import InteractSet from '../components/broadcast/InteractSet.vue';
import RemarkSet from '../components/broadcast/RemarkSet.vue';
import ContentSet from '../components/broadcast/ContentSet.vue';
import Forecast from '../components/broadcast/Forecast.vue';
import AdminVerifyBox from '../components/common/AdminVerifyBox.vue';
import massClient from '../apis';
import { MASS } from '@/mass/models/Mass';
import { BROADCAST } from '@/mass/models/Broadcast';
import MassSendMsg, { MassSendWxNews, MassSendWxCard, MassSendWxImage, MassSendWxText} from '@/mass/models/MassSendMsg';
import {transValue, transDiv } from '@/rule/models/ScheduleMsg';
import { resetCustomerFilter, CustomerFilter, InteractPeriod } from '@/customer/models/CustomerFilter';
import { TaskType } from '../../common/models/TaskType';
import commonClient from '../../common/apis';
import format from '../../customer/components/filter/makeCustomerQuery';
import FormatEmoji from '@/common/utils/FormatEmoji';

export default Vue.extend({
  mixins: [massVuex],
  components: {
    NotifySet,
    TimeSet,
    InteractSet,
    RemarkSet,
    ContentSet,
    Forecast,
    AdminVerifyBox,
  },
  data() {
    return {
      hasSelectedRemarks: false,
      confirmTerm: true,
      showAdminVerifyBox: false,
      MASS,
      BROADCAST,
    };
  },
  watch: {
    'broadcast.interactType'() {
      this.getExpectCount();
    },
    'broadcast.timeType'() {
      this.getExpectCount();
    },
    'broadcast.remarkSet'() {
      this.getExpectCount();
    },
  },
  computed: {
    tranProps(): any[] {
      const temp = JSON.parse(JSON.stringify(this.props));
      return temp.map((p: any) => {
        p.propName = '<drip-prop contenteditable="false">#' + p.propName + '</drip-prop>';
        return p;
      });
    },
  },
  methods: {
    getExpectCount() {
      let remarks: string[] | null = null;
      if (this.broadcast.remarkSet !== null && this.broadcast.remarkSet.length > 0) {
        remarks = this.broadcast.remarkSet!.map(r => r.remarkName);
      }
      massClient.getExpectCount({
        timeType: this.broadcast.timeType,
        interactType: this.broadcast.interactType,
        remarks,
      }).success((r) => {
        this.$store.commit('UPDATE_EXPECT_COUNT', r.count);
      });
    },
    confirmSend() {
      if (this.broadcast.interactType === this.BROADCAST.INTERACT_TYPE.NONE) {
        this.$Message.warning('请选择互动类型');
        return;
      }
      if (this.broadcast.contentType === this.BROADCAST.CONTENT_TYPE.TEXT && (this.broadcast.text === null || this.broadcast.text.length === 0)) {
        this.$Message.warning('请填写广播内容');
        return;
      }
      if (this.broadcast.contentType === this.BROADCAST.CONTENT_TYPE.NEWS && this.broadcast.newsId === undefined) {
        this.$Message.warning('请选择正确的图文消息');
        return;
      }
      if (this.broadcast.contentType === this.BROADCAST.CONTENT_TYPE.IMAGE && (this.broadcast.mediaId === null || this.broadcast.imageId === undefined || this.broadcast.imageUrl === null)) {
        this.$Message.warning('请选择正确的图片');
        return;
      }
      if (this.broadcast.contentType === this.BROADCAST.CONTENT_TYPE.COUPON && (this.broadcast.cardId === null && this.broadcast.couponId === null && this.broadcast.couponText === null)) {
        this.$Message.warning('请选择正确的优惠券');
        return;
      }
      if (this.broadcast.expectCount < 0) {
        this.$Message.warning('预计发送人数为0，请重新选择');
        return;
      }
      if (!this.confirmTerm) {
        this.$Message.warning('请阅读并勾选广播使用须知');
        return;
      }
      this.showAdminVerifyBox = true;
    },
    confirm() {
      const customerFilter = this.buildCustomerFilter();
      commonClient.createTask({
        input: {
          MassSend: {
            query: format.mkFilterQueries(customerFilter),
            msg: this.buildMsg(),
          },
        },
        expectCount: this.broadcast.expectCount,
        taskType: TaskType.Broadcast,
      }).success(() => {
        this.$Message.success('创建成功');
        this.$store.commit('INIT_BROADCAST');
        this.$router.push('/mass/records');
      }).failure((code: string, msg?: string) => {
        this.$Message.error(msg);
      }).error((e) => {
        this.$Message.error(e.toString());
      });
      this.showAdminVerifyBox = false;
    },
    buildMsg() {
      let msg: MassSendMsg | undefined;
      switch (this.broadcast.contentType) {
        case BROADCAST.CONTENT_TYPE.TEXT:
          msg = {
            WxText: {
              text: transDiv(transValue(this.tranProps, FormatEmoji.toEmoji(this.broadcast.text))),
              propConfigs: this.broadcast.propConfigs,
            } as MassSendWxText,
          } as MassSendMsg;
          break;
        case BROADCAST.CONTENT_TYPE.IMAGE:
          msg = {
            WxImage: {
              media: this.broadcast.mediaId,
              src: this.broadcast.imageUrl,
            } as MassSendWxImage,
          } as MassSendMsg;
          break;
        case BROADCAST.CONTENT_TYPE.COUPON:
          msg = {
            WxCard: {
              cardId: this.broadcast.cardId ? this.broadcast.cardId : null ,
              cardText: this.broadcast.couponText ? FormatEmoji.toEmoji(this.broadcast.couponText) : null,
            } as MassSendWxCard,
          } as MassSendMsg;
          break;
        case BROADCAST.CONTENT_TYPE.NEWS:
          msg = {
            WxNews: {
              newsId: this.broadcast.newsId,
              allowReprint: true,
              isToAll: true,
              mediaId: '',
              onlyFansCanComment: false,
              openComment: true,
              snapshot: JSON.stringify({}),
            } as MassSendWxNews,
          } as MassSendMsg;
          break;
        default:
          break;
      }
      return msg;
    },
    buildCustomerFilter(): CustomerFilter {
      const cf: CustomerFilter = resetCustomerFilter();
      if (this.broadcast.timeType === InteractPeriod.Today) {
        cf.interact.period = InteractPeriod.Today;
      }
      if (this.broadcast.timeType === InteractPeriod.TwoDays) {
        cf.interact.period = InteractPeriod.TwoDays;
      }
      if (this.broadcast.interactType === BROADCAST.INTERACT_TYPE.MESSAGE) {
        cf.interact.interactiveType = [BROADCAST.INTERACT_TYPE.TEXT, BROADCAST.INTERACT_TYPE.IMAGE , BROADCAST.INTERACT_TYPE.VOICE];
      }
      if (this.broadcast.interactType !== BROADCAST.INTERACT_TYPE.MESSAGE && this.broadcast.interactType !== BROADCAST.INTERACT_TYPE.ALL) {
        cf.interact.interactiveType = [this.broadcast.interactType];
      }
      if (this.broadcast.remarkSet && this.broadcast.remarkSet.length > 0) {
        cf.remark.remarks = this.broadcast.remarkSet;
      }
      return cf;
    },
  },
});
